/**
 * Échelle du curseur de `coef-slider.tsx`, sans React. Testée par
 * `coef-slider-scale.test.mjs`.
 */

import { formatDecimal } from '@gozoki/tools'

/** Coef ramené dans les bornes de la piste. */
export const clampCoef = (coef: number, min: number, max: number): number =>
  Math.min(max, Math.max(min, coef))

/** Décimales d'un pas : 0,05 → 2, 0,1 → 1, 1 → 0. */
const decimalsOf = (step: number): number => Math.max(0, Math.ceil(-Math.log10(step) - 1e-9))

/** Coef arrondi au pas (sans erreur de virgule flottante), puis ramené dans les bornes. */
export function snapCoef(coef: number, step: number, min: number, max: number): number {
  const snapped = Math.round(coef / step) * step
  return clampCoef(Number(snapped.toFixed(decimalsOf(step))), min, max)
}

/** Abscisse d'un coef sur la piste, de 0 à 1. */
export const coefPosition = (coef: number, min: number, max: number): number =>
  max === min ? 0 : (clampCoef(coef, min, max) - min) / (max - min)

/** « 1,60 ». */
export const formatCoefValue = (coef: number): string => formatDecimal(coef, 2)
